import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.2335 5.90634H13.2343H8.09371V0.775356C8.09371 0.353076 7.75179 0 7.32951 0H6.67174C6.24958 0 5.90618 0.353076 5.90618 0.775356V5.90634H0.765675C0.343626 5.90634 0 6.24781 0 6.6702V7.33173C0 7.75379 0.343512 8.09377 0.765675 8.09377H5.90629V13.2433C5.90629 13.6654 6.24958 14 6.67185 14H7.32963C7.7519 14 8.09382 13.6652 8.09382 13.2433V8.09377H13.2335C13.6558 8.09377 14 7.75367 14 7.33173V6.6702C14 6.24781 13.6558 5.90634 13.2335 5.90634Z"
        fill="#C4C4C4"
      />
    </Svg>
  );
};

export default Icon;
